export default __webpack_public_path__ + "static/media/logo-feeds.c6836d2e.svg";